export class ItemCategoryModel {
    id:number;
    name:string;
    children:ItemCategoryModel[] = [];
    constructor(item: any) {
        this.id = item.itemCategoryID;
        this.name = item.categoryName;
        this.children = item.children ? item.children.map((x:any) => new ItemCategoryModel(x)) : []; // Initialize children to an empty array if not provided
    }
}